export class ChangePasswordModel {
    Username: string;
    PwOld: string;
    PwNew: string;
    PwNewRepeat: string;

    constructor(username?: string, pwOld?: string, pwNew?: string, pwNewRepeat?: string) {
        if (username) {
          this.Username = username;
        }
        if (pwOld) {
          this.PwOld = pwOld;
        }
        if (pwNew) {
          this.PwNew = pwNew;
        }
        if (pwNewRepeat) {
          this.PwNewRepeat = pwNewRepeat;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/account/changepassword/entities/changePasswordModel.ts